<template>
  <div class="privacy-page">
    <PageTitle
      title="Privacy Policy"
      subtitle="Read here to learn how we use your information."
      backgroundClass="-banner is-dark -banner-04"
    />
    <section class="section">
      <div class="container">
        <div class="box">
          <PrivacyCopy />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PageTitle from "@/components/PageTitle.vue";
import PrivacyCopy from "@/components/copy/PrivacyCopy.vue";

export default {
  name: "privacyPage",
  components: {
    PageTitle,
    PrivacyCopy
  }
};
</script>

<style scoped lang="scss"></style>
